var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"view view--login"},[_c('img',{staticClass:"logo",attrs:{"src":"img/logo-negative.png","alt":"","width":"182"}}),_c('LoginForm',{on:{"loginsuccess":_vm.checkAccounts}}),_c('a',{staticClass:"forgot-pass",attrs:{"href":"https://app.prixo.io/password/reset"}},[_vm._v(_vm._s(_vm.$t("Forgot your password?")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }